export const ALLOWED_MEMBERS_EMAILS = [
   "icanio@duco.insure",
];

export const isEmailAllowedForMembers = (email) => {
  if (!email) return false;
  return ALLOWED_MEMBERS_EMAILS.map((e) => e.toLowerCase().trim()).includes(
    email.toLowerCase().trim()
  );
};
